'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compose = require('skald/lib/compose');

var _compose2 = _interopRequireDefault(_compose);

var _STR_TIME_INPUT = require('./_constants/STR_TIME_INPUT');

var _STR_TIME_INPUT2 = _interopRequireDefault(_STR_TIME_INPUT);

var _STR_TIME_LC = require('./_constants/STR_TIME_LC');

var _STR_TIME_LC2 = _interopRequireDefault(_STR_TIME_LC);

var _addDisplayName2 = require('./_internal/_addDisplayName');

var _addDisplayName3 = _interopRequireDefault(_addDisplayName2);

var _mergeType2 = require('./_internal/_mergeType');

var _mergeType3 = _interopRequireDefault(_mergeType2);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Alias for the input type="time" tag.  Should be used when adding a time field
 * to a form.
 *
 * @module TimeInput
 * @func
 * @since 1.0.0
 * @param {Object} props
 */

var mergeProps = (0, _mergeType3.default)(_STR_TIME_LC2.default);
var TimeInput = (0, _compose2.default)(_Input2.default, mergeProps);

exports.default = (0, _addDisplayName3.default)(TimeInput, _STR_TIME_INPUT2.default);